import React from "react";
import { Modal } from "antd";
import Button from "atoms/button/button";

interface DeleteModalProps {
  success: () => void;
  hideModal: () => void;
  title: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  success,
  hideModal,
  title = "item",
}) => {
  const handleDelete = () => {
    success();
    hideModal();
  };

  return (
    <Modal
      title="Confirm Deletion"
      visible={true}
      onCancel={hideModal}
      footer={[
        <Button isText handleClick={hideModal}>
          Cancel
        </Button>,
        <Button isPrimary handleClick={handleDelete}>
          Delete
        </Button>,
      ]}
    >
      Are you sure you want to delete this {title}?
    </Modal>
  );
};

export default DeleteModal;
